export default __webpack_public_path__ + "static/media/onboarding_3.206bcc5d.png";